import React from "react";
import Meaning from './Meaning';
import Phonetic from "./Phonetic";
import "./Results.css";

export default function Results(props){
    if (props.results){
        console.log(props.results);
        return (<div className="Results">
            <section>
                <h2>
            {props.results.word} </h2>
            {props.results.phonetics.map(function(phonetic, index){
                return(<div key={index}>
                    <Phonetic phonetic={phonetic}/>
                </div>)
            })}
            </section>
            <section>
{props.results.meanings.map(function(meaning, index){
                return (
                    <div key={index}>
                        <Meaning meaning={meaning} />
                        </div>
                )
            })}
            </section>
            
            
        
        
    </div>)
    } else {
        return null; 
    }
    }